// extracted by mini-css-extract-plugin
export var label = "_fb-2";
export var slideContainer = "_fb-0";
export var slider = "_fb-1";